import React from 'react';

import { Text } from '@chakra-ui/react';

import { createContainers, updateContainers } from 'api/containers';

import type { FormType } from '..';

export const containerForm: FormType = {
  createFn: createContainers,
  updateFn: updateContainers,
  cancelText: 'Cancelar',
  submitText: 'Salvar Embalagem',
  disableText: 'Excluir Embalagem',
  successText: 'Embalagem salva com sucesso!',
  fields: [
    [
      {
        name: 'name',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Caixa de isopor',
          label: 'Nome',
        },
      },
    ],
    [
      {
        name: 'height',
        type: 'text',
        required: true,
        props: {
          viewProps: {
            width: 90,
          },
          placeholder: '0',
          label: 'Altura',
          RightElement: () => (
            <Text
              variant="mediumRegular"
              color="gray.400">
              cm
            </Text>
          ),
        },
      },
      {
        name: 'width',
        type: 'text',
        required: true,
        props: {
          viewProps: {
            width: 90,
          },
          placeholder: '0',
          label: 'Largura',
          RightElement: () => (
            <Text
              variant="mediumRegular"
              color="gray.400">cm
            </Text>
          ),
        },
      },
      {
        name: 'depth',
        type: 'text',
        required: true,
        props: {
          viewProps: {
            width: 90,
          },
          placeholder: '0',
          label: 'Profundidade',
          RightElement: () => (
            <Text
              variant="mediumRegular"
              color="gray.400">cm
            </Text>
          ),
        },
      },
      {
        name: 'cubage',
        type: 'text',
        required: true,
        props: {
          viewProps: {
            flex: 1,
          },
          placeholder: '0',
          label: 'Cubagem',
          RightElement: () => (
            <Text
              variant="mediumRegular"
              color="gray.400">kg
            </Text>
          ),
        },
      },
    ],
  ],
};
